/* Namo — theme.js
 * Vanilla JS, no build step. Every feature initialises from data-attributes inside a root
 * so the theme editor can re-run it on shopify:section:load.
 */
(function () {
  'use strict';

  var BO = window.BO || {};
  var R = BO.routes || {};
  var S = BO.strings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var animOn = BO.animations !== false && !reduceMotion;
  var WISH_KEY = 'bo-wish-v2';
  var RECENT_KEY = 'bo-recent-v1';

  /* ---------------------------------------------------------------- utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, key) { var k = 'boInit' + key; if (el.dataset[k]) return false; el.dataset[k] = '1'; return true; }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function store(key, val) {
    try {
      if (val === undefined) { var r = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(r) ? r : []; }
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return []; }
    return val;
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || BO.moneyFormat || '{{amount}}';
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands; decimal = decimal == null ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var v;
    switch (match[1]) {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(match[0], v);
  }

  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) { var err = new Error(data.description || data.message || S.error || 'Error'); err.data = data; throw err; }
        return data;
      });
    });
  }

  /* ---------------------------------------------------------------- a11y: live region, focus, dialogs */
  // One polite live region (layout/theme.liquid [data-bo-live]) for status messages: bag count,
  // wishlist changes, search results, filter results, toasts. Clearing first makes repeats re-announce.
  var liveT;
  function announce(msg) {
    var r = $('[data-bo-live]'); if (!r || !msg) return;
    var text = String(msg).replace(/[✓♥→←↗✕]/g, ' ').replace(/\s+/g, ' ').trim();
    if (!text) return;
    r.textContent = '';
    clearTimeout(liveT);
    liveT = setTimeout(function () { r.textContent = text; }, 120);
  }

  var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, audio[controls], video[controls], summary, [contenteditable]:not([contenteditable="false"]), [tabindex]:not([tabindex="-1"])';
  function isShown(el) {
    if (!el || !el.isConnected || el.closest('[inert]')) return false;
    if (!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)) return false;
    return window.getComputedStyle(el).visibility !== 'hidden';
  }
  function focusables(root) { return $$(FOCUSABLE, root).filter(function (el) { return el.tabIndex >= 0 && isShown(el); }); }
  function focusEl(el) { if (!el) return false; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } return document.activeElement === el; }

  // Re-rendering markup (cart drawer, filters, wishlist grid) destroys the focused element. Run `mutate`
  // and then put focus back on the matching control (same id, or same name+value), else the control now
  // at the same tab position, else `fallback`.
  function preserveFocus(container, mutate, fallback) {
    var a = document.activeElement;
    if (!container || !a || a === document.body || !container.contains(a)) { mutate(); return; }
    var id = a.id, name = a.getAttribute('name'), val = a.value, idx = focusables(container).indexOf(a);
    mutate();
    if (document.activeElement && document.activeElement !== document.body && container.contains(document.activeElement) && document.activeElement.isConnected) return;
    var t = null;
    if (id) t = document.getElementById(id);
    if ((!t || !container.contains(t)) && name) t = $$('[name="' + (window.CSS && CSS.escape ? CSS.escape(name) : name) + '"]', container).filter(function (el) { return el.value === val; })[0] || null;
    if (!t || !isShown(t)) { var list = focusables(container); t = idx > -1 && list.length ? list[Math.min(idx, list.length - 1)] : null; }
    if (!focusEl(t) && fallback) focusEl(typeof fallback === 'function' ? fallback() : fallback);
  }

  // Shared modal helper for every overlay theme.js opens (cart drawer, search, mobile menu, filter sheet).
  // Stores the opener, moves focus in, traps Tab/Shift+Tab inside `scope`, makes everything outside
  // `scope` inert (aria-hidden where inert is unsupported), Escape calls `close`, focus returns on close.
  // Exposed as window.BO.a11y for section scripts (quick view, size guide...).
  var dialogs = [], lastClosed = null;
  var hasInert = typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
  var SKIP_INERT = 'script, style, link, template, noscript, [data-bo-live], [data-toast]';
  function inertOutside(scope) {
    var path = [], changed = [];
    scope.forEach(function (s) { for (var n = s; n && n !== document.documentElement; n = n.parentElement) if (path.indexOf(n) < 0) path.push(n); });
    path.forEach(function (n) {
      // Only walk the ancestors of the scope; never touch what is inside it
      if (scope.some(function (s) { return s === n || s.contains(n); })) return;
      Array.prototype.forEach.call(n.children, function (c) {
        if (path.indexOf(c) > -1 || c.matches(SKIP_INERT)) return;
        if (hasInert) { if (c.inert) return; c.inert = true; }
        else { if (c.getAttribute('aria-hidden') === 'true') return; c.setAttribute('aria-hidden', 'true'); }
        changed.push(c);
      });
    });
    return changed;
  }
  function releaseInert(list) { (list || []).forEach(function (c) { if (hasInert) c.inert = false; else c.removeAttribute('aria-hidden'); }); }
  function topDialog() { return dialogs[dialogs.length - 1]; }
  function openDialog(el, opts) {
    opts = opts || {};
    if (!el) return;
    closeDialog(el, { returnFocus: false });
    var rec = { el: el, scope: opts.scope || [el], close: opts.close, opener: opts.opener || document.activeElement };
    if (rec.opener === document.body) rec.opener = null;
    // Opened from inside an overlay that just closed (e.g. search -> bag): return to that overlay's opener
    if (rec.opener && lastClosed && lastClosed.el.contains(rec.opener)) rec.opener = lastClosed.opener;
    // Release the previous dialog's background so only this one's applies
    var prev = topDialog(); if (prev) { releaseInert(prev.inerted); prev.inerted = null; }
    rec.inerted = inertOutside(rec.scope);
    dialogs.push(rec);
    var target = typeof opts.focus === 'function' ? opts.focus() : opts.focus;
    requestAnimationFrame(function () {
      if (topDialog() !== rec) return;
      if (!focusEl(target) && !focusEl(focusables(el)[0])) { if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1'); focusEl(el); }
    });
  }
  function closeDialog(el, opts) {
    opts = opts || {};
    var i = -1; dialogs.forEach(function (d, k) { if (d.el === el) i = k; });
    if (i < 0) return;
    var rec = dialogs.splice(i, 1)[0];
    lastClosed = rec;
    releaseInert(rec.inerted);
    var prev = topDialog(); if (prev && !prev.inerted) prev.inerted = inertOutside(prev.scope);
    if (opts.returnFocus !== false) {
      var o = rec.opener;
      if (!(o && isShown(o) && focusEl(o))) { if (prev) focusEl(focusables(prev.el)[0]); else focusEl($('#MainContent')); }
    }
  }
  function onDialogKey(e) {
    var d = topDialog(); if (!d) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (e.defaultPrevented) return;
      e.preventDefault();
      if (d.close) d.close(); else closeDialog(d.el);
      return;
    }
    if (e.key !== 'Tab') return;
    var list = [];
    d.scope.forEach(function (s) { list = list.concat(focusables(s)); });
    list.sort(function (a, b) { return a === b ? 0 : (a.compareDocumentPosition(b) & 4 ? -1 : 1); });
    if (!list.length) { e.preventDefault(); focusEl(d.el); return; }
    var first = list[0], last = list[list.length - 1], a = document.activeElement;
    var inside = d.scope.some(function (s) { return s.contains(a); });
    if (e.shiftKey && (a === first || !inside)) { e.preventDefault(); focusEl(last); }
    else if (!e.shiftKey && (a === last || !inside)) { e.preventDefault(); focusEl(first); }
  }
  document.addEventListener('keydown', onDialogKey);

  // Tabs: arrow keys / Home / End move between role="tab" buttons and activate them (click),
  // with a roving tabindex so the tablist is one Tab stop.
  function syncTabindex(list) {
    var tabs = $$('[role="tab"]', list); if (!tabs.length) return;
    var sel = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    tabs.forEach(function (t) { t.tabIndex = t === sel ? 0 : -1; });
  }
  function initTablists(root) {
    $$('[role="tablist"]', root).forEach(function (list) {
      syncTabindex(list);
      if (!once(list, 'Tabs')) return;
      if ('MutationObserver' in window) new MutationObserver(function () { syncTabindex(list); }).observe(list, { subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
      on(list, 'keydown', function (e) {
        var tabs = $$('[role="tab"]', list).filter(function (t) { return !t.disabled && !t.hidden; });
        var i = tabs.indexOf(e.target); if (i < 0) return;
        var vertical = list.getAttribute('aria-orientation') === 'vertical';
        var n = null;
        if (e.key === (vertical ? 'ArrowDown' : 'ArrowRight')) n = (i + 1) % tabs.length;
        else if (e.key === (vertical ? 'ArrowUp' : 'ArrowLeft')) n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n === null) return;
        e.preventDefault();
        focusEl(tabs[n]); tabs[n].click();
      });
    });
  }

  var toastT;
  function toast(text, cta, href, srText) {
    var t = $('[data-toast]'); if (!t) return;
    $('[data-toast-text]', t).textContent = text;
    var c = $('[data-toast-cta]', t);
    if (cta) { c.textContent = cta; c.href = href || R.cart; c.hidden = false; } else { c.hidden = true; }
    t.hidden = false; t.style.animation = 'none'; void t.offsetWidth; t.style.animation = '';
    announce(srText || text);
    clearTimeout(toastT);
    // Stays up while hovered or focused so the button can be reached
    var hide = function () { if (t.matches(':hover') || t.contains(document.activeElement)) { toastT = setTimeout(hide, 1200); return; } t.hidden = true; };
    toastT = setTimeout(hide, reduceMotion ? 6000 : 4000);
  }

  function lock(state) { document.body.classList.toggle('bo-locked', !!state); }

  /* ---------------------------------------------------------------- header */
  function initHeader() {
    var header = $('[data-header]'); if (!header || !once(header, 'Header')) return;
    var setH = function () { document.documentElement.style.setProperty('--bo-header-h', header.offsetHeight + 'px'); };
    setH(); on(window, 'resize', setH);
    if (header.hasAttribute('data-header-overlay')) {
      var solid = function () { header.classList.toggle('is-solid', window.scrollY > 40); };
      solid(); on(window, 'scroll', solid, { passive: true });
    }
  }

  /* ---------------------------------------------------------------- overlays: menu, search */
  var menuEl, searchEl;
  function closeOverlays() {
    if (menuEl && !menuEl.hidden) toggleMenu(false);
    if (searchEl && !searchEl.hidden) toggleSearch(false);
    closeCart();
    $$('[data-coll].is-filters-open').forEach(function (c) { if (window.innerWidth < 820) setFilters(c, false); });
  }
  function toggleMenu(force, opts) {
    menuEl = menuEl || $('[data-mobile-menu]'); if (!menuEl) return;
    var open = force == null ? menuEl.hidden : force;
    var opener = document.activeElement;
    if (open) {
      if (searchEl && !searchEl.hidden) toggleSearch(false, { returnFocus: false });
      closeCart({ returnFocus: false });
    }
    menuEl.hidden = !open; lock(open);
    var header = $('[data-header]'); if (header) header.classList.toggle('is-menu-open', open);
    $$('[data-toggle-menu]').forEach(function (b) {
      b.setAttribute('aria-expanded', open);
      var lbl = open ? b.dataset.labelClose : b.dataset.labelOpen;
      if (!lbl) return;
      // Icon buttons keep their icons and only change the label read by screen readers.
      if (b.hasAttribute('data-icon-only')) b.setAttribute('aria-label', lbl); else b.textContent = lbl;
    });
    // The close control is the header's menu button, so the header stays reachable with the menu
    // (header + menu form the trapped scope; main, footer and the rest of the page go inert).
    if (open) openDialog(menuEl, { opener: opener, scope: header ? [header, menuEl] : [menuEl], focus: function () { return focusables(menuEl)[0]; }, close: function () { toggleMenu(false); } });
    else closeDialog(menuEl, opts);
  }
  function toggleSearch(force, opts) {
    searchEl = searchEl || $('[data-search-overlay]'); if (!searchEl) return;
    var open = force == null ? searchEl.hidden : force;
    var opener = document.activeElement;
    if (open) {
      if (menuEl && !menuEl.hidden) toggleMenu(false, { returnFocus: false });
      closeCart({ returnFocus: false });
    }
    searchEl.hidden = !open; lock(open);
    if (open) openDialog(searchEl, { opener: opener, focus: function () { return $('[data-search-input]', searchEl); }, close: function () { toggleSearch(false); } });
    else closeDialog(searchEl, opts);
  }

  function initSearch() {
    searchEl = $('[data-search-overlay]'); if (!searchEl || !once(searchEl, 'Search')) return;
    var input = $('[data-search-input]', searchEl);
    var list = $('[data-search-results]', searchEl);
    var label = $('[data-search-label]', searchEl);
    var empty = $('[data-search-empty]', searchEl);
    var all = $('[data-search-all]', searchEl);
    var initial = list.innerHTML, t, ctrl;
    function run(q) {
      q = q.trim();
      if (!q) { list.innerHTML = initial; label.textContent = label.dataset.default; empty.hidden = true; all.hidden = true; return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = (R.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: ctrl && ctrl.signal }).then(function (r) { return r.json(); }).then(function (d) {
        var res = (d.resources && d.resources.results) || {};
        var prods = res.products || [];
        var others = [].concat(res.collections || [], res.pages || [], res.articles || []);
        var html = prods.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? '<img src="' + escapeHtml(p.featured_image.url) + '&width=88" alt="" loading="lazy" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover">' : '<span class="bo-ph"></span>';
          return '<a href="' + escapeHtml(p.url) + '" class="bo-search__result"><span class="bo-search__result-main"><span class="bo-search__thumb bo-media">' + img + '</span><span class="bo-search__result-name">' + escapeHtml(p.title) + '</span></span><span class="bo-search__result-price">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
        }).join('') + others.map(function (o) {
          return '<a href="' + escapeHtml(o.url) + '" class="bo-search__result"><span class="bo-search__result-name">' + escapeHtml(o.title) + '</span><span class="bo-search__result-price" aria-hidden="true">→</span></a>';
        }).join('');
        var n = prods.length + others.length;
        list.innerHTML = html;
        label.textContent = (list.dataset.resultsLabel || '[n] RESULTS').replace('[n]', n);
        empty.hidden = n > 0;
        all.hidden = n === 0; all.href = (R.search || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
        announce(n > 0 ? label.textContent : empty.textContent);
      }).catch(function () {});
    }
    on(input, 'input', function () { clearTimeout(t); t = setTimeout(function () { run(input.value); }, 180); });
    $$('[data-search-term]', searchEl).forEach(function (b) { on(b, 'click', function () { input.value = b.dataset.searchTerm; run(input.value); input.focus(); }); });
  }

  /* ---------------------------------------------------------------- cart */
  function cartSections() {
    var ids = ['cart-drawer'];
    var page = $('[data-cart-page]');
    if (page) ids.push(page.dataset.sectionId);
    return ids;
  }
  function renderSections(sections) {
    if (!sections) return;
    var dh = sections['cart-drawer'];
    if (dh) {
      var doc = new DOMParser().parseFromString(dh, 'text/html');
      var fresh = $('[data-drawer-inner]', doc), cur = $('[data-drawer-inner]');
      if (fresh && cur) {
        preserveFocus(cur, function () { cur.innerHTML = fresh.innerHTML; }, function () { return $('.bo-drawer__close', cur); });
        initMagnetic(cur);
      }
    }
    var page = $('[data-cart-page]');
    if (page && sections[page.dataset.sectionId]) {
      var d2 = new DOMParser().parseFromString(sections[page.dataset.sectionId], 'text/html');
      var f2 = $('[data-cart-page]', d2);
      if (f2) { preserveFocus(page, function () { page.innerHTML = f2.innerHTML; }, function () { return $('#MainContent'); }); initAll(page); }
    }
  }
  var lastCount = null;
  function cartCountText(n) {
    var tpl = n === 1 ? (S.cartCountOne || '[n] item in your bag') : (S.cartCountOther || '[n] items in your bag');
    return tpl.replace('[n]', n);
  }
  function updateCounts(count) {
    var els = $$('[data-cart-count]');
    if (lastCount === null && els[0]) lastCount = parseInt(els[0].textContent, 10);
    els.forEach(function (el) { el.textContent = count; });
    if (count !== lastCount) announce(cartCountText(count));
    lastCount = count;
  }
  function refreshCount() { return fetchJSON((R.cart || '/cart') + '.js').then(function (c) { updateCounts(c.item_count); return c; }); }

  function openCart() {
    if ($('[data-cart-page]')) { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); return; }
    var d = $('[data-cart-drawer]'); if (!d) { window.location.href = R.cart || '/cart'; return; }
    var opener = document.activeElement;
    if (menuEl && !menuEl.hidden) toggleMenu(false, { returnFocus: false });
    if (searchEl && !searchEl.hidden) toggleSearch(false, { returnFocus: false });
    if (d.classList.contains('is-open')) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); d.inert = false; d.removeAttribute('inert'); lock(true);
    openDialog(d, { opener: opener, focus: function () { return $('.bo-drawer__close', d); }, close: function () { closeCart(); } });
  }
  function closeCart(opts) {
    var d = $('[data-cart-drawer]'); if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); d.setAttribute('inert', ''); lock(false);
    closeDialog(d, opts);
  }

  function addToCart(items, opts) {
    opts = opts || {};
    return fetchJSON((R.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      body: JSON.stringify({ items: items, sections: cartSections(), sections_url: window.location.pathname })
    }).then(function (res) {
      renderSections(res.sections);
      return refreshCount().then(function () {
        if (opts.silent) return res;
        if ($('[data-cart-page]')) toast(opts.message || S.added || 'Added', null);
        else openCart();
        return res;
      });
    }).catch(function (e) { toast(e.message || S.error); throw e; });
  }

  // Lens lines (added by the lens picker) carry _lens_group/_lens_for: they always match their frame's
  // quantity and are removed with it.
  function syncLensLines(cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);
    var frames = {}, updates = {}, n = 0;
    cart.items.forEach(function (it) { var p = it.properties || {}; if (p._lens_group && !p._lens_for) frames[p._lens_group] = (frames[p._lens_group] || 0) + it.quantity; });
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (!p._lens_for || !p._lens_group) return;
      var q = frames[p._lens_group] || 0;
      if (q !== it.quantity) { updates[it.key] = q; n++; }
    });
    if (!n) return Promise.resolve(cart);
    return fetchJSON((R.cartUpdate || '/cart/update') + '.js', {
      method: 'POST',
      body: JSON.stringify({ updates: updates, sections: cartSections(), sections_url: window.location.pathname })
    }).then(function (res) { renderSections(res.sections); updateCounts(res.item_count); return res; });
  }

  function changeLine(key, qty) {
    var targets = $$('[data-key="' + key + '"]');
    targets.forEach(function (t) { t.classList.add('is-loading'); });
    return fetchJSON((R.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty), sections: cartSections(), sections_url: window.location.pathname })
    }).then(function (res) {
      renderSections(res.sections); updateCounts(res.item_count);
      return syncLensLines(res);
    }).catch(function (e) {
      targets.forEach(function (t) { t.classList.remove('is-loading'); });
      toast(e.message || S.error);
    });
  }

  function initCartGlobal() {
    if (!once(document.body, 'CartGlobal')) return;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-open-cart]');
      if (t) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('[data-close-cart]')) { e.preventDefault(); closeCart(); return; }

      var q = e.target.closest('[data-qty-change]');
      if (q) { e.preventDefault(); changeLine(q.dataset.qtyChange, parseInt(q.dataset.qty, 10)); return; }

      var add = e.target.closest('[data-quick-add]');
      if (add) {
        e.preventDefault(); e.stopPropagation();
        if (add.disabled) return;
        var original = add.innerHTML;
        add.disabled = true; add.classList.add('is-loading');
        addToCart([{ id: parseInt(add.dataset.quickAdd, 10), quantity: 1 }]).then(function () {
          add.classList.remove('is-loading'); add.classList.add('is-added');
          add.innerHTML = add.hasAttribute('data-glyph') ? '<span aria-hidden="true">✓</span>' : '<span aria-hidden="true">✓</span> ' + escapeHtml(add.dataset.labelAdded || S.added || 'Added');
          setTimeout(function () { add.innerHTML = original; add.classList.remove('is-added'); add.disabled = false; }, 1600);
        }).catch(function () { add.classList.remove('is-loading'); add.disabled = false; });
        return;
      }

      var save = e.target.closest('[data-save-later]');
      if (save) {
        e.preventDefault();
        var item = parseWish(save.dataset.wishItem);
        if (item) wishAdd(item);
        changeLine(save.dataset.saveLater, 0).then(function () { toast((item ? item.title + ' ' : '') + '♥', S.viewSaved || 'VIEW SAVED', R.wishlist, (item ? item.title + ' — ' : '') + (S.wishAdded || 'Saved')); });
        return;
      }

      if (e.target.closest('[data-promo-apply]')) {
        var inp = $('[data-promo-input]'), msg = $('[data-promo-msg]');
        var code = inp ? inp.value.trim() : '';
        if (!code) {
          if (msg) { msg.hidden = false; if (!msg.matches('[role="alert"], [role="status"], [aria-live]')) announce(msg.textContent); }
          if (inp) { inp.setAttribute('aria-invalid', 'true'); if (msg && msg.id) inp.setAttribute('aria-describedby', msg.id); inp.focus(); }
          return;
        }
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(R.cart || '/cart');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-promo-input]')) { e.preventDefault(); var b = $('[data-promo-apply]'); if (b) b.click(); }
    });
    document.addEventListener('change', function (e) {
      var i = e.target.closest && e.target.closest('[data-qty-input]');
      if (i) changeLine(i.dataset.qtyInput, parseInt(i.value, 10) || 0);
      var note = e.target.closest && e.target.closest('[data-cart-note]');
      if (note) fetchJSON((R.cartUpdate || '/cart/update') + '.js', { method: 'POST', body: JSON.stringify({ note: note.value }) }).catch(function () {});
    });
  }

  /* ---------------------------------------------------------------- wishlist */
  function parseWish(str) { try { return JSON.parse(str); } catch (e) { return null; } }
  function wishList() { return store(WISH_KEY); }
  function wishHas(handle) { return wishList().some(function (w) { return w.handle === handle; }); }
  function wishAdd(item) { var l = wishList(); if (!l.some(function (w) { return w.handle === item.handle; })) { l.push(item); store(WISH_KEY, l); } syncWish(); }
  function wishRemove(handle) { store(WISH_KEY, wishList().filter(function (w) { return w.handle !== handle; })); syncWish(); }
  function syncWish() {
    var l = wishList();
    $$('[data-wish-count]').forEach(function (el) { el.textContent = l.length; });
    $$('[data-wish-toggle]').forEach(function (b) {
      var has = l.some(function (w) { return w.handle === b.dataset.wishToggle; });
      b.classList.toggle('is-saved', has);
      b.setAttribute('aria-pressed', has);
      if (b.dataset.labelOn) b.textContent = has ? b.dataset.labelOn : b.dataset.labelOff;
    });
    renderWishlistPage();
  }
  function initWishGlobal() {
    if (!once(document.documentElement, 'Wish')) return;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wish-toggle]'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var h = b.dataset.wishToggle;
      var it = parseWish(b.dataset.wishItem), name = it && it.title ? it.title + ' — ' : '';
      if (wishHas(h)) { wishRemove(h); announce(name + (S.wishRemoved || 'Removed from saved')); }
      else if (it) {
        wishAdd(it); announce(name + (S.wishAdded || 'Saved'));
        if (animOn && b.animate) b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 350 });
      }
    });
    on(window, 'storage', function (e) { if (e.key === WISH_KEY) syncWish(); });
    on(window, 'pageshow', syncWish);
  }

  function renderWishlistPage() {
    var page = $('[data-wishlist-page]'); if (!page) return;
    var l = wishList();
    var grid = $('[data-wl-grid]', page);
    var countLbl = $('[data-wl-count-label]', page);
    $('[data-wl-empty]', page).hidden = l.length > 0;
    $('[data-wl-section]', page).hidden = l.length === 0;
    $('[data-wl-actions]', page).hidden = l.length === 0;
    if (countLbl) countLbl.textContent = l.length + ' ' + (l.length === 1 ? countLbl.dataset.one : countLbl.dataset.many);
    grid.innerHTML = l.map(function (w) {
      // The image link repeats the name link below it, so it is skipped by keyboard and screen readers
      var img = w.image ? '<img src="' + escapeHtml(w.image) + '" alt="" loading="lazy">' : '<div class="bo-ph" aria-hidden="true"><span class="bo-ph__label">' + escapeHtml(w.title) + '</span></div>';
      var btn = w.variant && w.available !== false
        ? '<button type="button" class="bo-btn bo-btn--dark bo-btn--block bo-wl__add" style="min-height:48px" data-wl-add="' + escapeHtml(w.handle) + '">' + escapeHtml(grid.dataset.labelAdd) + '</button>'
        : '<a href="' + escapeHtml(w.url) + '" class="bo-btn bo-btn--outline bo-btn--block" style="min-height:48px">' + escapeHtml(grid.dataset.labelView) + '</a>';
      return '<div class="bo-wl__card"><a href="' + escapeHtml(w.url) + '" class="bo-media" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<button type="button" class="bo-wish is-saved" data-wl-remove="' + escapeHtml(w.handle) + '" aria-label="' + escapeHtml((grid.dataset.labelRemove || 'Remove') + ': ' + w.title) + '"><span aria-hidden="true">♥</span></button>' +
        '<div class="bo-wl__body"><div class="bo-wl__row"><div style="display:flex;flex-direction:column;gap:5px;min-width:0"><a href="' + escapeHtml(w.url) + '" class="bo-wl__name">' + escapeHtml(w.title) + '</a><span class="bo-mono bo-mono--sm bo-muted-2">' + escapeHtml(w.spec || '') + '</span></div>' +
        '<span style="font-size:14px;font-weight:500;white-space:nowrap">' + formatMoney(w.price) + '</span></div>' + btn + '</div></div>';
    }).join('');
    // hide suggestions already saved
    $$('[data-suggest-handle]', page).forEach(function (s) { s.hidden = l.some(function (w) { return w.handle === s.dataset.suggestHandle; }); });
  }
  function initWishlistPage(root) {
    var page = $('[data-wishlist-page]', root); if (!page || !once(page, 'WL')) return;
    on(page, 'click', function (e) {
      var r = e.target.closest('[data-wl-remove]');
      if (r) {
        e.preventDefault();
        var rw = wishList().filter(function (x) { return x.handle === r.dataset.wlRemove; })[0];
        preserveFocus(page, function () { wishRemove(r.dataset.wlRemove); }, function () { return $('#MainContent'); });
        announce((rw ? rw.title + ' — ' : '') + (S.wishRemoved || 'Removed from saved'));
        return;
      }
      var a = e.target.closest('[data-wl-add]');
      if (a) {
        var w = wishList().filter(function (x) { return x.handle === a.dataset.wlAdd; })[0]; if (!w) return;
        a.disabled = true;
        addToCart([{ id: w.variant, quantity: 1 }], { silent: true }).then(function () {
          a.innerHTML = '<span aria-hidden="true">✓</span> ' + escapeHtml($('[data-wl-grid]', page).dataset.labelAdded); a.classList.add('is-added');
          toast(w.title + ' ✓', S.viewBag || 'VIEW BAG', R.cart, w.title + ' — ' + (S.added || 'Added'));
          setTimeout(function () { a.disabled = false; a.textContent = $('[data-wl-grid]', page).dataset.labelAdd; a.classList.remove('is-added'); }, 1600);
        }).catch(function () { a.disabled = false; });
        return;
      }
      if (e.target.closest('[data-wl-move-all]')) {
        var l = wishList(), items = l.filter(function (w) { return w.variant && w.available !== false; });
        if (!items.length) return;
        addToCart(items.map(function (w) { return { id: w.variant, quantity: 1 }; }), { silent: true }).then(function () {
          var moved = items.map(function (w) { return w.handle; });
          store(WISH_KEY, l.filter(function (w) { return moved.indexOf(w.handle) < 0; })); syncWish();
          toast(items.length + ' → BAG', S.viewBag || 'VIEW BAG', R.cart, (S.added || 'Added') + ' (' + items.length + ')');
        });
        return;
      }
      var sh = e.target.closest('[data-wl-share]');
      if (sh) {
        var handles = wishList().map(function (w) { return w.handle; }).join(',');
        var url = window.location.origin + window.location.pathname + '?saved=' + encodeURIComponent(handles);
        var done = function () { var o = sh.innerHTML; sh.innerHTML = '<span aria-hidden="true">✓</span> ' + escapeHtml(sh.dataset.copied); announce(sh.dataset.copied); setTimeout(function () { sh.innerHTML = o; }, 1800); };
        if (navigator.share) navigator.share({ url: url }).catch(function () {});
        else if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
      }
    });
    // Import a shared list (?saved=handle1,handle2)
    var shared = new URLSearchParams(window.location.search).get('saved');
    if (shared) {
      Promise.all(shared.split(',').filter(Boolean).slice(0, 24).map(function (h) {
        return fetchJSON('/products/' + encodeURIComponent(h) + '.js').then(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          return { handle: p.handle, title: p.title, url: p.url, price: v.price, image: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=720' : '', spec: p.type || '', variant: v.id, available: p.available };
        }).catch(function () { return null; });
      })).then(function (items) { items.filter(Boolean).forEach(wishAdd); history.replaceState(null, '', window.location.pathname); });
    }
    renderWishlistPage();
  }

  /* ---------------------------------------------------------------- recently viewed */
  function recordRecent(p) {
    var l = store(RECENT_KEY).filter(function (x) { return x.handle !== p.handle; });
    l.unshift(p); store(RECENT_KEY, l.slice(0, 12));
  }
  function initRecent(root) {
    $$('[data-recently-viewed]', root).forEach(function (sec) {
      var ex = sec.dataset.exclude, lim = parseInt(sec.dataset.limit, 10) || 4;
      var l = store(RECENT_KEY).filter(function (x) { return x.handle !== ex; }).slice(0, lim);
      if (!l.length) { sec.hidden = true; return; }
      $('[data-recent-list]', sec).innerHTML = l.map(function (p) {
        // The product name is in the same link, so the image is decorative here
        var img = p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy">' : '<div class="bo-ph" aria-hidden="true"><span class="bo-ph__label">' + escapeHtml(p.title) + '</span></div>';
        return '<a class="bo-tile" href="' + escapeHtml(p.url) + '"><span class="bo-media">' + img + '</span><span class="bo-meta"><span class="bo-tile__name" style="font-size:15px">' + escapeHtml(p.title) + '</span><span style="font-size:13px">' + formatMoney(p.price) + '</span></span></a>';
      }).join('');
      sec.hidden = false;
    });
  }

  /* ---------------------------------------------------------------- product page */
  function initProduct(root) {
    $$('[data-product-page]', root).forEach(function (pg) {
      if (!once(pg, 'PDP')) return;
      var data = parseWish($('[data-product-json]', pg).textContent) || { variants: [] };
      var form = $('form[id^="ProductForm"]', pg) || $('form[action*="/cart/add"]', pg);
      var idInput = $('[data-variant-id]', pg);
      var stage = $('[data-stage]', pg);
      var slides = $$('[data-slide]', pg);
      var thumbs = $$('[data-thumb]', pg);
      var addBtn = $('[data-add-button]', pg);
      var addLabel = $('[data-add-label]', pg);
      var priceEl = $('[data-price]', pg);
      var pricePlain = $('[data-price-plain]', pg);
      var stickyAdd = $('[data-sticky-add]', pg);
      var errEl = $('[data-form-error]', pg);
      var cur = data.variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || data.variants[0];
      var active = 0;

      var isFeatured = pg.hasAttribute('data-featured');
      if (!isFeatured) recordRecent({ handle: data.handle, title: data.title, url: data.url, price: cur ? cur.price : 0, image: data.image });

      /* gallery */
      function go(i) {
        if (!slides.length) return;
        active = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { var on_ = k === active; s.classList.toggle('is-active', on_); if ('inert' in s) s.inert = !on_; else s.setAttribute('aria-hidden', on_ ? 'false' : 'true'); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === active); if (t.hasAttribute('aria-current')) t.setAttribute('aria-current', k === active ? 'true' : 'false'); if (t.getAttribute('role') === 'tab') t.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
        $$('video', pg).forEach(function (v) { if (!v.closest('.is-active')) v.pause(); });
      }
      thumbs.forEach(function (t) { on(t, 'click', function () { setView('photo'); go(parseInt(t.dataset.thumb, 10)); }); });
      on($('[data-slide-prev]', pg), 'click', function () { go(active - 1); });
      on($('[data-slide-next]', pg), 'click', function () { go(active + 1); });
      if (slides.length) go(0);
      // swipe
      var sx = null;
      on(stage, 'touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      on(stage, 'touchend', function (e) {
        if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
        var v = $('[data-view="photo"]', pg); if (v && v.hidden) return;
        if (Math.abs(dx) > 40) go(active + (dx < 0 ? 1 : -1));
      });
      // zoom
      if (canHover) slides.forEach(function (s) {
        if (s.dataset.zoom !== 'true') return;
        var z = $('.bo-pdp__zoom', s); if (!z) return;
        on(s, 'mousemove', function (e) { var r = s.getBoundingClientRect(); z.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; z.style.transform = 'scale(1.6)'; });
        on(s, 'mouseleave', function () { z.style.transform = ''; });
      });
      // views
      function setView(name) {
        $$('[data-view]', pg).forEach(function (v) { v.hidden = v.dataset.view !== name; });
        $$('[data-view-tab]', pg).forEach(function (t) { var a = t.dataset.viewTab === name; t.classList.toggle('is-active', a); t.setAttribute('aria-selected', a); });
        if (name !== 'film') $$('[data-view="film"] video', pg).forEach(function (v) { v.pause(); });
      }
      $$('[data-view-tab]', pg).forEach(function (t) { on(t, 'click', function () { setView(t.dataset.viewTab); }); });
      // 360
      var spin = $('[data-spin]', pg), range = $('[data-spin-range]', pg), deg = $('[data-spin-deg]', pg);
      if (spin && range) {
        var frames = $$('img', spin), n = frames.length;
        var show = function (i) { i = ((i % n) + n) % n; frames.forEach(function (f, k) { f.classList.toggle('is-on', k === i); }); range.value = i; if (deg) deg.textContent = Math.round(i / n * 360) + '°'; };
        on(range, 'input', function () { show(parseInt(range.value, 10)); });
        var dragX = null, start = 0;
        var view = spin.parentElement;
        on(view, 'pointerdown', function (e) { if (e.target === range) return; dragX = e.clientX; start = parseInt(range.value, 10); view.setPointerCapture && view.setPointerCapture(e.pointerId); });
        on(view, 'pointermove', function (e) { if (dragX == null) return; show(start + Math.round((dragX - e.clientX) / 12)); });
        on(view, 'pointerup', function () { dragX = null; });
        on(view, 'pointercancel', function () { dragX = null; });
      }

      /* variants */
      var opts = $$('[data-option-index]', pg);
      function selected() {
        return opts.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      }
      function findVariant(sel) {
        return data.variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); })[0];
      }
      function updateDeltas(sel) {
        opts.forEach(function (fs) {
          var idx = parseInt(fs.dataset.optionIndex, 10);
          var cells = $$('[data-delta]', fs); if (!cells.length) return;
          var prices = cells.map(function (c) { var s = sel.slice(); s[idx] = c.dataset.delta; var v = findVariant(s); return v ? v.price : null; });
          var base = Math.min.apply(null, prices.filter(function (p) { return p != null; }));
          cells.forEach(function (c, k) {
            var p = prices[k];
            c.textContent = p == null ? '—' : p > base ? '+ ' + formatMoney(p - base) : (c.closest('.bo-pdp__opt').dataset.includedLabel || 'Included');
          });
        });
        // availability marks
        opts.forEach(function (fs) {
          var idx = parseInt(fs.dataset.optionIndex, 10);
          $$('input', fs).forEach(function (inp) {
            var s = sel.slice(); s[idx] = inp.value; var v = findVariant(s);
            inp.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      }
      function applyVariant(v, fromUser) {
        if (!v) {
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = S.unavailable || 'Unavailable';
          if (fromUser) announce(S.unavailable || 'Unavailable');
          return;
        }
        cur = v;
        if (idInput && String(idInput.value) !== String(v.id)) {
          idInput.value = v.id;
          // Shop Pay Installments and other listeners watch the form's id input.
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var priceHtml = (v.compare > v.price ? '<span class="visually-hidden">' + escapeHtml(S.regularPrice || 'Regular price') + '</span><s>' + formatMoney(v.compare) + '</s><span class="visually-hidden">' + escapeHtml(S.salePrice || 'Sale price') + '</span>' : '') + formatMoney(v.price) +
          (v.unit ? '<span class="bo-unit-price"><span class="visually-hidden">' + escapeHtml(S.unitPrice || 'Unit price') + '</span>' + escapeHtml(v.unit) + '</span>' : '');
        if (priceEl) priceEl.innerHTML = priceHtml;
        if (pricePlain) pricePlain.textContent = formatMoney(v.price);
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? (S.addToBag || 'Add to bag') + ' — ' + formatMoney(v.price) : (S.soldOut || 'Sold out');
        if (stickyAdd) { stickyAdd.disabled = !v.available; stickyAdd.textContent = v.available ? (S.addToBag || 'Add to bag') : (S.soldOut || 'Sold out'); }
        var sku = $('[data-sku]', pg); if (sku) sku.textContent = v.sku ? 'SKU ' + v.sku : '';
        if (v.media && fromUser) {
          var k = slides.map(function (s) { return s.dataset.mediaId; }).indexOf(String(v.media));
          if (k > -1) { go(k); }
        }
        applyQtyRule(v);
        loadPickup(pg, v);
        if (fromUser && !isFeatured && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
        // update wish payload price/variant
        $$('[data-wish-toggle]', pg).forEach(function (b) { var w = parseWish(b.dataset.wishItem); if (w) { w.variant = v.id; w.price = v.price; w.available = v.available; b.dataset.wishItem = JSON.stringify(w); } });
        $$('[data-bundle-item][data-main]').forEach(function (b) { b.dataset.variant = v.id; b.dataset.price = v.price; var pe = $('[data-bundle-price]', b); if (pe) pe.textContent = formatMoney(v.price); });
        updateBundles();
      }
      opts.forEach(function (fs) {
        on(fs, 'change', function (e) {
          var sel = selected();
          var lbl = $('[data-option-label]', fs); if (lbl) lbl.textContent = e.target.value;
          var tint = e.target.dataset.tint;
          if (tint && stage) stage.style.setProperty('--bo-tint', 'color-mix(in srgb, ' + tint + ' 14%, #F8F7F5)');
          applyVariant(findVariant(sel), true);
          updateDeltas(sel);
          // Tell screen reader users what the new choice costs / whether it can be bought
          if (cur && findVariant(sel) && addLabel) announce(e.target.value + ' — ' + addLabel.textContent);
        });
      });
      if (opts.length) {
        updateDeltas(selected());
        var chk = $('[data-option-index] input:checked[data-tint]', pg);
        if (chk && chk.dataset.tint && stage) stage.style.setProperty('--bo-tint', 'color-mix(in srgb, ' + chk.dataset.tint + ' 14%, #F8F7F5)');
      }

      /* qty: respects the variant's quantity rule (min, max, increment) */
      function applyQtyRule(v) {
        var i = $('[data-qty-input-main]', pg); if (!i || !v) return;
        var min = v.qmin || 1, step = v.qstep || 1;
        i.min = min; i.step = step;
        if (v.qmax) i.max = v.qmax; else i.removeAttribute('max');
        var val = parseInt(i.value, 10) || min;
        if (val < min) i.value = min;
        var rule = $('[data-qty-rule]', pg);
        if (rule) rule.hidden = min === 1 && step === 1 && !v.qmax;
      }
      $$('[data-qty-step]', pg).forEach(function (b) {
        on(b, 'click', function () {
          var i = $('input[name="quantity"]', pg); if (!i) return;
          var step = parseInt(i.step, 10) || 1, min = parseInt(i.min, 10) || 1, max = parseInt(i.max, 10) || Infinity;
          var next = (parseInt(i.value, 10) || min) + step * parseInt(b.dataset.qtyStep, 10);
          i.value = Math.min(max, Math.max(min, next));
        });
      });
      loadPickup(pg, cur);

      /* submit */
      function submit() {
        if (!cur || !cur.available) return;
        var q = $('input[name="quantity"]', pg);
        var props = {};
        if (form) {
          var gcEmail = $('[data-gift-recipient] input[type="email"]:not([disabled])', form);
          if (gcEmail && !gcEmail.checkValidity()) { gcEmail.reportValidity(); return; }
          $$('[name^="properties["]', form).forEach(function (i) { if (!i.disabled && ((i.type !== 'checkbox' && i.type !== 'radio') || i.checked)) props[i.name.slice(11, -1)] = i.value; });
        }
        if (errEl) errEl.hidden = true;
        if (addBtn) addBtn.classList.add('is-loading');
        addToCart([{ id: cur.id, quantity: q ? Math.max(parseInt(q.min, 10) || 1, parseInt(q.value, 10) || 1) : 1, properties: props }]).then(function () {
          if (addBtn) addBtn.classList.remove('is-loading');
          if (addLabel) { addLabel.innerHTML = '<span aria-hidden="true">✓</span> ' + escapeHtml(S.added || 'Added'); setTimeout(function () { applyVariant(cur); }, 1600); }
        }).catch(function (e) {
          if (addBtn) addBtn.classList.remove('is-loading');
          if (errEl) { errEl.hidden = false; errEl.textContent = e.message; if (!errEl.matches('[role="alert"], [aria-live]')) announce(e.message); }
        });
      }
      on(form, 'submit', function (e) { e.preventDefault(); submit(); });
      on(stickyAdd, 'click', submit);

      /* sticky bar visibility */
      var sticky = $('[data-sticky-atc]', pg);
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { sticky.classList.toggle('is-visible', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(addBtn);
      }

      /* AR */
      if ($('[data-shopify-xr]', pg) && window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'shopify-xr', version: '1.0', onLoad: function (err) {
          if (err || !window.ShopifyXR) return;
          var j = document.getElementById('ProductModels');
          if (j) { try { window.ShopifyXR.addModels(JSON.parse(j.textContent)); } catch (e) {} }
          window.ShopifyXR.setupXRElements();
        } }, { name: 'model-viewer-ui', version: '1.0', onLoad: function () {} }]);
      }
    });
  }

  /* ---------------------------------------------------------------- pickup availability */
  function loadPickup(pg, v) {
    var box = $('[data-pickup]', pg); if (!box || !v) return;
    if (!v.available) { box.hidden = true; box.innerHTML = ''; return; }
    var url = (box.dataset.rootUrl || '/') + 'variants/' + v.id + '/?section_id=pickup-availability';
    box.dataset.variant = v.id;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      if (String(box.dataset.variant) !== String(v.id)) return;
      var d = new DOMParser().parseFromString(html, 'text/html');
      var c = $('[data-pickup-content]', d);
      box.innerHTML = c ? c.outerHTML : '';
      box.hidden = !c;
    }).catch(function () { box.hidden = true; });
  }

  /* ---------------------------------------------------------------- gift card recipient, localization */
  function initFormHelpers() {
    if (!once(document.documentElement, 'Forms')) return;
    document.addEventListener('change', function (e) {
      var gc = e.target.closest('[data-gc-toggle]');
      if (gc) {
        var wrap = gc.closest('[data-gift-recipient]'), fields = $('[data-gc-fields]', wrap);
        fields.hidden = !gc.checked;
        $$('input, textarea', fields).forEach(function (i) { i.disabled = !gc.checked; });
        var off = $('[data-gc-offset]', wrap); if (off) off.value = new Date().getTimezoneOffset();
        if (gc.checked) { var em = $('input[type="email"]', fields); if (em) em.focus(); }
        return;
      }
      var loc = e.target.closest('[data-locale-select]');
      if (loc && loc.form) loc.form.submit();
    });
  }

  /* ---------------------------------------------------------------- bundle */
  function updateBundles() {
    $$('[data-bundle]').forEach(function (b) {
      var items = $$('[data-bundle-item]', b);
      var on_ = items.filter(function (i) { var c = $('input', i); return c && c.checked; });
      items.forEach(function (i) { var c = $('input', i); if (c) i.classList.toggle('is-off', !c.checked); });
      var disc = parseInt(b.dataset.discount, 10) || 0;
      var sum = on_.reduce(function (a, i) { return a + (parseInt(i.dataset.price, 10) || 0); }, 0);
      var final = on_.length > 1 ? Math.round(sum * (100 - disc) / 100) : sum;
      var tot = $('[data-bundle-total]', b), cnt = $('[data-bundle-count]', b);
      if (tot) tot.innerHTML = formatMoney(final) + (final < sum ? '<s>' + formatMoney(sum) + '</s>' : '');
      if (cnt) cnt.textContent = on_.length + ' ×';
      var btn = $('[data-bundle-add]', b); if (btn) btn.disabled = on_.length === 0;
    });
  }
  function initBundle(root) {
    $$('[data-bundle]', root).forEach(function (b) {
      if (!once(b, 'Bundle')) return;
      on(b, 'change', updateBundles);
      on($('[data-bundle-add]', b), 'click', function (e) {
        var btn = e.currentTarget;
        var items = $$('[data-bundle-item]', b).filter(function (i) { var c = $('input', i); return c && c.checked; }).map(function (i) { return { id: parseInt(i.dataset.variant, 10), quantity: 1 }; });
        if (!items.length) return;
        btn.classList.add('is-loading');
        addToCart(items).then(function () { btn.classList.remove('is-loading'); }, function () { btn.classList.remove('is-loading'); });
      });
    });
    updateBundles();
  }

  /* ---------------------------------------------------------------- recommendations */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (sec) {
      if (!once(sec, 'Reco') || sec.children.length) return;
      fetch(sec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var f = $('[data-recommendations]', d);
        if (f && f.innerHTML.trim()) { sec.innerHTML = f.innerHTML; syncWish(); initReveal(sec); }
        else sec.hidden = true;
      }).catch(function () { sec.hidden = true; });
    });
  }

  /* ---------------------------------------------------------------- collection: filters, sort, infinite */
  function setFilters(coll, open, opts) {
    var opener = document.activeElement;
    coll.classList.toggle('is-filters-open', open);
    var sec = coll.closest('[data-collection]') || coll.parentElement;
    var panel = $('.bo-filters', coll) || $('.bo-filters', sec);
    $$('.bo-filter-btn', sec).forEach(function (b) { b.classList.toggle('is-active', open); });
    // Every toggle outside the panel (sidebar button, mobile floating button) reports its state
    $$('button[data-filters-toggle]', sec).forEach(function (b) {
      if (panel && panel.contains(b)) return;
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel && panel.id && !b.hasAttribute('aria-controls')) b.setAttribute('aria-controls', panel.id);
    });
    if (window.innerWidth < 820) {
      lock(open);
      // On mobile the panel is a bottom sheet over the page: treat it as a modal dialog
      if (panel) {
        if (open) {
          panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
          openDialog(panel, { opener: opener, focus: function () { return focusables($('[data-filter-form]', panel) || panel)[0]; }, close: function () { setFilters(coll, false); } });
        } else {
          closeDialog(panel, opts);
        }
      }
    } else if (panel && !open) {
      closeDialog(panel, { returnFocus: false });
    }
    if (panel && (!open || window.innerWidth >= 820)) { panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); }
  }
  function initCollection(root) {
    $$('[data-collection]', root).forEach(function (sec) {
      if (!once(sec, 'Coll')) return;
      var coll = $('[data-coll]', sec);
      var form = $('[data-filter-form]', sec);
      var sort = $('[data-sort]', sec);
      var sid = sec.dataset.sectionId;
      if (window.innerWidth < 820 && coll.classList.contains('is-filters-open')) setFilters(coll, false, { returnFocus: false });

      on(sec, 'click', function (e) {
        if (e.target.closest('[data-filters-toggle]')) { e.preventDefault(); setFilters(coll, !coll.classList.contains('is-filters-open')); return; }
        var a = e.target.closest('[data-filter-link], [data-filter-clear]');
        if (a) { e.preventDefault(); load(a.href); }
      });

      function params() {
        var fd = form ? new FormData(form) : new FormData();
        var p = new URLSearchParams();
        fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
        if (sort && sort.value) p.set('sort_by', sort.value);
        if (sec.dataset.searchTerms && !p.has('q')) { p.set('q', sec.dataset.searchTerms); p.set('options[prefix]', 'last'); }
        return p.toString();
      }
      var t;
      function load(url) {
        var u = new URL(url, window.location.origin);
        var fetchUrl = new URL(u.toString()); fetchUrl.searchParams.set('section_id', sid);
        var results = $('[data-coll-results]', sec); results.classList.add('is-loading');
        fetch(fetchUrl.toString()).then(function (r) { return r.text(); }).then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          var swap = function (sel) { var a = $(sel, sec), b = $(sel, d); if (a && b) a.innerHTML = b.innerHTML; };
          // Keep keyboard focus on the filter the shopper just changed
          preserveFocus(sec, function () { swap('[data-coll-results]'); swap('[data-filter-groups]'); }, function () { return $('[data-coll-results]', sec); });
          $$('[data-result-count]', sec).forEach(function (el) { var n = $('[data-result-count]', d); if (n) el.innerHTML = n.innerHTML; });
          $$('[data-filter-count]', sec).forEach(function (el) { var n = $('[data-filter-count]', d); if (n) el.innerHTML = n.innerHTML; });
          var sc = $('.bo-sheet-close', sec), nsc = $('.bo-sheet-close', d); if (sc && nsc) sc.textContent = nsc.textContent;
          var cl = $('[data-filter-clear]', sec), ncl = $('[data-filter-clear]', d); if (cl && ncl) cl.href = ncl.href;
          results.classList.remove('is-loading');
          var rc = $('[data-result-count]', sec); if (rc && !rc.matches('[role="status"], [aria-live]')) announce(rc.textContent);
          history.replaceState({}, '', u.pathname + u.search);
          initPriceRange(sec); initInfinite(sec); syncWish();
        }).catch(function () { window.location.href = u.toString(); });
      }
      function onChange() { clearTimeout(t); t = setTimeout(function () { load(window.location.pathname + '?' + params()); }, 350); }
      on(form, 'change', onChange);
      on(form, 'submit', function (e) { e.preventDefault(); onChange(); });
      on(sort, 'change', onChange);
      initPriceRange(sec);
      initInfinite(sec);
    });
  }
  function initPriceRange(sec) {
    $$('[data-price-range]', sec).forEach(function (pr) {
      var slider = $('[data-price-slider]', pr), max = $('[data-price-max]', pr), label = $('[data-price-label]', pr);
      if (!slider || !max) return;
      on(slider, 'input', function () { max.value = slider.value; if (label) label.textContent = label.textContent.replace(/[\d,.]+$/, slider.value); });
      on(slider, 'change', function () { max.dispatchEvent(new Event('change', { bubbles: true })); });
    });
  }
  // Infinite scroll on top of a real "Load more" link ([data-sentinel-more]): search engines and
  // keyboard users follow/click the link, everyone else gets the next page as they scroll.
  function initInfinite(sec) {
    var s = $('[data-sentinel][data-next-url]', sec); if (!s) return;
    var busy = false, io = null;
    var lbl = $('[data-sentinel-label]', s), more = $('[data-sentinel-more]', s), spin = $('[data-sentinel-spin]', s);
    function loadNext(moveFocus) {
      var next = s.dataset.nextUrl;
      if (!next) { if (io) io.disconnect(); return; }
      if (busy) return;
      busy = true;
      if (spin) spin.hidden = false;
      var orig = lbl ? lbl.textContent : ''; if (lbl) lbl.textContent = lbl.dataset.loading;
      var u = new URL(next, window.location.origin); u.searchParams.set('section_id', sec.dataset.sectionId);
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-coll-grid]', sec), ng = $('[data-coll-grid]', d), firstNew = null;
        if (grid && ng) Array.prototype.slice.call(ng.children).forEach(function (c, i) { if (!firstNew) firstNew = c; c.style.animationDelay = (i % 6) * 0.05 + 's'; grid.appendChild(c); });
        var ns = $('[data-sentinel]', d), nl = ns && $('[data-sentinel-label]', ns);
        if (ns && ns.dataset.nextUrl) {
          s.dataset.nextUrl = ns.dataset.nextUrl;
          if (more) more.href = ns.dataset.nextUrl;
          if (lbl && nl) lbl.textContent = nl.textContent;
        } else {
          delete s.dataset.nextUrl;
          if (more) { more.remove(); more = null; }
          if (lbl) lbl.textContent = nl ? nl.textContent : orig;
          if (io) io.disconnect();
        }
        if (spin) spin.hidden = true; busy = false; syncWish();
        // After a click on "Load more", continue from the first newly added product
        if (moveFocus && firstNew) focusEl($('a[href]', firstNew) || firstNew);
      }).catch(function () { busy = false; if (spin) spin.hidden = true; if (lbl) lbl.textContent = orig; });
    }
    if (more) on(more, 'click', function (e) { e.preventDefault(); loadNext(true); });
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) loadNext(false); }, { rootMargin: '300px' });
      io.observe(s);
    }
  }

  /* ---------------------------------------------------------------- hero */
  function initHero(root) {
    $$('[data-hero]', root).forEach(function (hero) {
      if (!once(hero, 'Hero')) return;
      var slides = $$('[data-hero-slide]', hero), tabs = $$('[data-hero-tab]', hero);
      var dur = parseInt(hero.dataset.duration, 10) || 6500, cur = 0, timer;
      function set(i) {
        if (i === cur || !slides[i]) return;
        slides.forEach(function (s, k) { s.classList.remove('is-prev'); if (k !== i && k !== cur) s.classList.remove('is-active'); });
        slides[cur].classList.remove('is-active'); slides[cur].classList.add('is-prev');
        void slides[i].offsetWidth;
        slides[i].classList.add('is-active');
        tabs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i); });
        var s = slides[i].dataset;
        $$('[data-hero-no]', hero).forEach(function (el) { el.textContent = s.no; });
        var tag = $('[data-hero-tag]', hero); if (tag) tag.textContent = s.tag;
        var nm = $('[data-hero-name]', hero); if (nm) nm.textContent = s.name;
        var pr = $('[data-hero-price]', hero); if (pr) pr.textContent = s.price;
        var card = $('[data-hero-card]', hero); if (card && s.url) card.href = s.url;
        cur = i;
      }
      // No autoplay under reduced motion, or while paused with the section's pause button (.is-paused)
      function start() { clearInterval(timer); if (reduceMotion || slides.length < 2 || hero.classList.contains('is-paused')) return; timer = setInterval(function () { set((cur + 1) % slides.length); }, dur); }
      tabs.forEach(function (t) { on(t, 'click', function () { set(parseInt(t.dataset.heroTab, 10)); start(); }); });
      // restart the progress fill on the first tab so it animates from 0
      if (tabs[0]) { tabs[0].classList.remove('is-active'); void tabs[0].offsetWidth; requestAnimationFrame(function () { tabs[0].classList.add('is-active'); }); }
      start();
      hero._boStop = function () { clearInterval(timer); };
      if (hero.dataset.lens === 'true') initLens(hero);
    });
  }
  function initLens(hero) {
    var stage = $('[data-lens-stage]', hero), mask = $('[data-lens-mask]', hero), ring = $('[data-lens-ring]', hero);
    if (!stage || !mask || !ring) return;
    var Rr = 100, O = 112;
    function size() {
      var w = stage.clientWidth;
      Rr = Math.round(Math.max(58, Math.min(136, w * 0.085))); O = Math.round(Rr * 1.16);
      stage.style.setProperty('--lr', Rr + 'px'); stage.style.setProperty('--lo', O + 'px');
    }
    size(); on(window, 'resize', size);
    var g = function (dx) { return 'radial-gradient(circle at calc(var(--lx) ' + (dx < 0 ? '- ' : '+ ') + 'var(--lo)) var(--ly), transparent calc(var(--lr) - 1px), #000 var(--lr))'; };
    var m = g(-1) + ',' + g(1);
    mask.style.webkitMaskImage = m; mask.style.maskImage = m;
    mask.style.webkitMaskComposite = 'source-in'; mask.style.maskComposite = 'intersect';
    var tx = null, ty = null, cx = stage.clientWidth * 0.62, cy = stage.clientHeight * 0.4, last = 0, visible = true;
    on(window, 'pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var r = stage.getBoundingClientRect();
      if (e.clientY < r.top || e.clientY > r.bottom) return;
      tx = e.clientX - r.left; ty = e.clientY - r.top; last = performance.now();
    }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) raf = requestAnimationFrame(loop); }).observe(stage);
    requestAnimationFrame(function () { ring.classList.add('is-on'); });
    var t0 = performance.now(), raf;
    function loop(now) {
      if (!visible) return;
      raf = requestAnimationFrame(loop);
      var W = stage.clientWidth, H = stage.clientHeight, gx = tx, gy = ty;
      if (gx === null || now - last > 3500) {
        var t = reduceMotion ? 0 : (now - t0) / 1000;
        gx = W * (0.56 + 0.2 * Math.sin(t * 0.32)); gy = H * (0.38 + 0.1 * Math.sin(t * 0.47 + 1));
      }
      cx += (gx - cx) * 0.09; cy += (gy - cy) * 0.09;
      stage.style.setProperty('--lx', cx.toFixed(1) + 'px'); stage.style.setProperty('--ly', cy.toFixed(1) + 'px');
      ring.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px)';
    }
    raf = requestAnimationFrame(loop);
  }

  /* ---------------------------------------------------------------- fit finder */
  function initFinder(root) {
    $$('[data-finder]', root).forEach(function (f) {
      if (!once(f, 'Finder')) return;
      var steps = $$('[data-finder-step]', f), results = $$('[data-finder-result]', f);
      var bar = $('[data-finder-bar]', f), label = $('[data-finder-label]', f);
      var decide = parseInt(f.dataset.resultQ, 10) || 0;
      var answers = [], step = 0;
      function show() {
        var done = step >= steps.length;
        steps.forEach(function (s, i) { s.hidden = done || i !== step; });
        results.forEach(function (r) { r.hidden = true; });
        if (bar) bar.style.width = Math.min(100, (step / Math.max(1, steps.length)) * 100) + '%';
        if (label) label.textContent = done ? label.dataset.result : label.dataset.tpl.replace('[n]', step + 1);
        if (done) {
          var key = answers[Math.min(decide, answers.length - 1)];
          var r = results.filter(function (x) { return x.dataset.finderResult === key; })[0] || results[0];
          if (r) r.hidden = false;
        }
      }
      on(f, 'click', function (e) {
        var p = e.target.closest('[data-finder-pick]');
        if (p) { answers[step] = p.dataset.finderPick; step++; show(); return; }
        if (e.target.closest('[data-finder-restart]')) { answers = []; step = 0; show(); }
      });
      show();
    });
  }

  /* ---------------------------------------------------------------- instagram slider */
  function initIG(root) {
    $$('[data-ig]', root).forEach(function (sec) {
      if (!once(sec, 'IG')) return;
      var track = $('[data-ig-track]', sec), prev = $('[data-ig-prev]', sec), next = $('[data-ig-next]', sec);
      var counter = $('[data-ig-counter]', sec), bar = $('[data-ig-bar]', sec);
      var posts = $$('.bo-ig__post', track), n = posts.length, raf;
      function step() { var c = posts[0]; return c ? c.getBoundingClientRect().width + 16 : track.clientWidth; }
      function measure() {
        var max = track.scrollWidth - track.clientWidth;
        var p = max > 0 ? track.scrollLeft / max : 0;
        var vis = track.scrollWidth > 0 ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
        var idx = Math.min(n - 1, Math.round(track.scrollLeft / step()));
        if (counter) counter.textContent = pad2(idx + 1) + ' / ' + pad2(n);
        if (prev) prev.disabled = p <= 0.001;
        if (next) next.disabled = max <= 1 || p >= 0.999;
        if (bar) { bar.style.width = (vis * 100).toFixed(2) + '%'; bar.style.transform = 'translateX(' + (vis > 0 ? (p * (1 - vis) / vis * 100) : 0).toFixed(2) + '%)'; }
      }
      on(track, 'scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; measure(); }); }, { passive: true });
      on(prev, 'click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      on(next, 'click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      on(track, 'keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); next.click(); } if (e.key === 'ArrowLeft') { e.preventDefault(); prev.click(); } });
      on(window, 'resize', measure);
      measure(); setTimeout(measure, 300);
    });
  }

  /* ---------------------------------------------------------------- 404 */
  function init404(root) {
    var s = $('[data-404]', root); if (!s || !once(s, '404')) return;
    var lens = $('.bo-404__lens', s);
    on(window, 'pointermove', function (e) {
      if (!lens) return;
      var r = lens.getBoundingClientRect();
      var dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2), d = Math.max(1, Math.hypot(dx, dy));
      lens.style.setProperty('--px', (dx / d).toFixed(3)); lens.style.setProperty('--py', (dy / d).toFixed(3));
    }, { passive: true });
  }

  /* ---------------------------------------------------------------- motion */
  function initMagnetic(root) {
    if (!canHover || !animOn) return;
    $$('[data-magnetic]', root).forEach(function (el) {
      if (!once(el, 'Mag')) return;
      el.style.transition = (el.style.transition ? el.style.transition + ',' : '') + 'transform .4s cubic-bezier(.22,1,.36,1)';
      on(el, 'mousemove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.2).toFixed(1) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.3).toFixed(1) + 'px)';
      });
      on(el, 'mouseleave', function () { el.style.transform = ''; });
    });
  }
  function initCursor() {
    var c = $('[data-bo-cursor]'); if (!c || !canHover || !once(c, 'Cursor')) return;
    var x = -100, y = -100, raf;
    on(window, 'mousemove', function (e) {
      x = e.clientX - 6; y = e.clientY - 6;
      if (!raf) raf = requestAnimationFrame(function () { raf = null; c.style.transform = 'translate(' + x + 'px,' + y + 'px)'; });
    }, { passive: true });
    on(document, 'mouseover', function (e) { c.classList.toggle('is-hover', !!e.target.closest('a, button, [role="button"], label, select')); });
    on(document, 'mouseleave', function () { c.style.transform = 'translate(-100px,-100px)'; });
  }
  function initReveal(root) {
    var els = $$('[data-reveal]', root).filter(function (el) { return !el.classList.contains('is-revealed'); });
    if (!animOn || !('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) { els.forEach(function (el) { el.classList.add('is-revealed'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  function initCounters(root) {
    $$('[data-count]', root).forEach(function (el) {
      if (!once(el, 'Count')) return;
      var target = parseFloat(el.dataset.count); if (isNaN(target)) return;
      var b = el.closest('[data-benefit]');
      if (!animOn || !('IntersectionObserver' in window)) { if (b) b.classList.add('is-in'); return; }
      el.textContent = '0';
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect();
        if (b) b.classList.add('is-in');
        var t0 = performance.now(), d = 1600;
        (function tick(now) {
          var k = Math.min(1, (now - t0) / d), e = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(target * e).toLocaleString('en-IN');
          if (k < 1) requestAnimationFrame(tick);
        })(t0);
      }, { threshold: 0.4 });
      io.observe(el);
    });
    $$('[data-benefit]', root).forEach(function (b) { if (!$('[data-count]', b) && 'IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { b.classList.add('is-in'); io.disconnect(); } }); io.observe(b); } else if (!$('[data-count]', b)) b.classList.add('is-in'); });
  }

  var gsapTries = 0;
  function initScrollMotion(root) {
    var words = $$('[data-statement]', root), pins = $$('[data-hz-pin]', root);
    if (!words.length && !pins.length) return;
    if (!animOn) { pins.forEach(function (p) { p.classList.add('is-native'); }); $$('[data-word]', root).forEach(function (w) { w.style.opacity = 1; }); return; }
    if (!window.gsap || !window.ScrollTrigger) {
      if (gsapTries++ < 40) { setTimeout(function () { initScrollMotion(root); }, 150); return; }
      // GSAP failed to load: graceful fallback
      pins.forEach(function (p) { p.classList.add('is-native'); });
      $$('[data-word]', root).forEach(function (w) { w.style.opacity = 1; });
      return;
    }
    var gsap = window.gsap, ST = window.ScrollTrigger;
    gsap.registerPlugin(ST);
    words.forEach(function (st) {
      if (!once(st, 'Words')) return;
      gsap.to($$('[data-word]', st), { opacity: 1, stagger: 0.08, ease: 'none', scrollTrigger: { trigger: st, start: 'top 75%', end: 'bottom 45%', scrub: 0.6 } });
    });
    var mm = gsap.matchMedia ? gsap.matchMedia() : null;
    pins.forEach(function (pin) {
      if (!once(pin, 'Pin')) return;
      var track = $('[data-hz-track]', pin);
      if (!track || pin.dataset.hzPin === 'false') { pin.classList.add('is-native'); return; }
      var setup = function () {
        var dist = function () { return Math.max(0, track.scrollWidth - window.innerWidth + 96); };
        var tw = gsap.to(track, { x: function () { return -dist(); }, ease: 'none', scrollTrigger: { trigger: pin, pin: true, scrub: 1, end: function () { return '+=' + dist(); }, invalidateOnRefresh: true } });
        return function () { tw.scrollTrigger && tw.scrollTrigger.kill(); tw.kill(); gsap.set(track, { x: 0 }); };
      };
      if (mm) {
        mm.add('(min-width: 820px)', setup);
        mm.add('(max-width: 819px)', function () { pin.classList.add('is-native'); return function () { pin.classList.remove('is-native'); }; });
      } else if (window.innerWidth >= 820) setup(); else pin.classList.add('is-native');
    });
    // refresh once images settle
    on(window, 'load', function () { ST.refresh(); });
  }

  /* ---------------------------------------------------------------- misc */
  function initCountrySelects(root) {
    $$('select[data-default]', root).forEach(function (s) { if (s.dataset.default) s.value = s.dataset.default; });
  }
  function initRecoverToggle(root) {
    $$('[data-toggle-recover]', root).forEach(function (a) {
      if (!once(a, 'Rec')) return;
      on(a, 'click', function (e) { e.preventDefault(); var r = $('#recover'); if (r) { r.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' }); var i = $('input[type=email]', r); (i || r).focus({ preventScroll: true }); } });
    });
  }

  function initGlobalUI() {
    if (!once(document.documentElement, 'UI')) return;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-toggle-menu]')) { e.preventDefault(); toggleMenu(); return; }
      if (e.target.closest('[data-open-search]')) { e.preventDefault(); toggleSearch(true); return; }
      if (e.target.closest('[data-search-close]')) { e.preventDefault(); toggleSearch(false); return; }
      if (e.target.closest('[data-close-overlays]')) { toggleMenu(false); }
    });
    // Open dialogs handle Escape themselves (onDialogKey) and mark the event handled
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !e.defaultPrevented) closeOverlays(); });
    on(window, 'resize', function () {
      if (window.innerWidth >= 820 && menuEl && !menuEl.hidden) toggleMenu(false);
    });
  }

  /* ---------------------------------------------------------------- boot */
  function initAll(root) {
    root = root || document;
    initHero(root); initFinder(root); initIG(root); initCollection(root); initProduct(root); initBundle(root);
    initRecommendations(root); initRecent(root); initWishlistPage(root); init404(root);
    initMagnetic(root); initReveal(root); initCounters(root); initScrollMotion(root);
    initCountrySelects(root); initRecoverToggle(root); initTablists(root);
    syncWish();
  }

  /* After a customer/contact/comment form posts back, move focus to its error or success message */
  function initFormFeedback() {
    var m = document.querySelector('[data-form-errors], [data-form-status]');
    if (!m) return;
    var d = m.closest('details'); if (d) d.open = true;
    try { m.focus({ preventScroll: false }); } catch (e) { m.focus(); }
  }

  function boot() {
    initFormFeedback();
    initGlobalUI(); initHeader(); initSearch(); initCartGlobal(); initWishGlobal(); initCursor(); initFormHelpers();
    initAll(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    initHeader(); initAll(e.target);
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-hero]', e.target).forEach(function (h) { if (h._boStop) h._boStop(); });
    if (window.ScrollTrigger) window.ScrollTrigger.getAll().forEach(function (t) { if (e.target.contains(t.trigger)) t.kill(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-hero-slide]');
    if (slide) { var hero = slide.closest('[data-hero]'); var tabs = $$('[data-hero-tab]', hero); var i = $$('[data-hero-slide]', hero).indexOf(slide); if (tabs[i]) tabs[i].click(); if (hero._boStop) hero._boStop(); }
    var step = e.target.closest('[data-finder-step]');
    if (step) { $$('[data-finder-step]', step.parentElement).forEach(function (s) { s.hidden = s !== step; }); }
  });

  window.BO.a11y = { openDialog: openDialog, closeDialog: closeDialog, focusables: focusables, announce: announce, preserveFocus: preserveFocus };
  window.BO.formatMoney = formatMoney;
  window.BO.addToCart = addToCart;
  window.BO.openCart = openCart;
})();
